export default {
  setTeamDeployments: (state, payload) => {
    state.teamDeployments = payload;
  },
};
